import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PortConsumptionReportDownloadPopupComponent } from './port-consumption-report-download-popup.component';

@NgModule({
  declarations: [PortConsumptionReportDownloadPopupComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [PortConsumptionReportDownloadPopupComponent],
})
export class PortConsumptionReportDownloadPopupModule {}
